export interface ITrackingCode {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  path?: string;
}

export class TrackingCode {
  public utmSource: string;
  public utmMedium: string;
  public utmCampaign: string;
  public path?: string;

  constructor(data: ITrackingCode) {
    this.utmSource = data.utmSource;
    this.utmMedium = data.utmMedium;
    this.utmCampaign = data.utmCampaign;
    this.path = data.path;
  }
}
